'use client';

export const PolicyDrawer = () => (
  <div className="flex flex-grow flex-col gap-3 p-4">
    <p className="text-sm text-foreground/90">
      Sua privacidade é importante para nós. Esta seção descreve, de forma resumida, como
      coletamos, usamos e protegemos seus dados.
    </p>

    <div className="space-y-4 text-sm">
      <section>
        <h3 className="font-semibold mb-1">Coleta de Dados</h3>
        <p className="text-foreground/80">
          Coletamos informações fornecidas por você e dados técnicos necessários para
          garantir a melhor experiência de uso da plataforma.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-1">Uso das Informações</h3>
        <p className="text-foreground/80">
          Utilizamos seus dados para oferecer funcionalidades essenciais, melhorar nossos
          serviços e comunicar atualizações relevantes.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-1">Seus Direitos</h3>
        <p className="text-foreground/80">
          Você pode solicitar acesso, correção ou remoção de seus dados, conforme a
          legislação aplicável.
        </p>
      </section>
    </div>
  </div>
);
